// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import "babel-polyfill"
import router from '@/router'
import store from '@/store'
import GeminiScrollbar from 'vue-gemini-scrollbar'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import plugins from '@/common/util/plugins'

// 引入分页组件
import pagination from '@/components/pagination';
import { GetInfo } from '@/fetch/com'

import '@/style/common.scss'


//剪切板插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 图片裁剪
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.use(elementUI, { size: 'small' });
Vue.use(GeminiScrollbar);

//全局插件
Object.keys(plugins).forEach((key,index)=>{
    Vue.use(plugins[key][0],plugins[key][1]||{});
})

//全局组件
Vue.component('elPage', pagination);

// 全局指令
Vue.directive('auth', {
    bind: function(el, binding) {
        if (!Vue.prototype.$_auth(binding.value)) {
            el.parentNode.removeChild(el);
        }
    }
});

Vue.config.productionTip = false

//开发环境，开启vue调试工具
if (process.env.NODE_ENV === 'development') {
    Vue.config.devtools = true
}
//全局导航卫视
router.beforeEach((to, from, next) => {
    let token = GetInfo('token') || '';
    if(to.path != '/login' && to.path != '/register' && !token){
        next('/login')
    }else{
        next();
    }
});



new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})
